import { Tag } from "antd-mobile";
import "./AdviceCard.less";
import { AdviceItem, ReplyStatus } from "@/config/types/mailbox";
export default function AdviceCard({ info }: { info: AdviceItem }) {
  const { adviceTypeDesc, adviceDesc, submitTime, replyTime, replyStatus, replyContent } =
    info || {};

  return (
    <div className="mailbox-card">
      <div className="title-wrap">
        <div className="title">留言</div>
        {adviceTypeDesc && (
          <Tag color="primary" className="type-tag">
            {adviceTypeDesc}
          </Tag>
        )}
      </div>
      <div className="content">{adviceDesc}</div>
      <div className="time">{submitTime}</div>
      <div className="replay-box">
        {replyStatus === ReplyStatus.YES && (
          <div className="replay-title">
            <div className="label">回复</div>
            <div className="replay-time">{replyTime}</div>
          </div>
        )}
        <div className="replay-content">
          {replyStatus === ReplyStatus.YES ? replyContent : "留言已收悉，将在7个工作日内向您反馈"}
        </div>
      </div>
    </div>
  );
}
